import React, {useState} from 'react'
import {useHistory} from 'react-router';
import ButtonSection from '../../../UI/ButtonSection';
import {Row, Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import ApprovalsButton from '../../../components/ApproveButton/ApprovalsButton';
import BusyActionButton from '../../../components/ActionButton/BusyActionButton';

const PCIActionButtons = ({
                              cancelRoute,
                              approvalRoute,
                              onSave,
                              onSubmitPci,
                              isSaveDisabled,
                              isDisabledSubmitPci = false,
                              saveInProgress,
                              isDisabledSubmitManually = false,
                          }) => {


    const [openModal, setOpenModal] = useState(false);
    const toggle = () => setOpenModal(!openModal);
    let history = useHistory();

    const onConfirmCancel = () => {
        toggle();
        history.push(cancelRoute);
    }

    return (
        <Row>
            <ButtonSection>
                <Button color="link" data-testid="CancelLink" onClick={toggle} className="m-1">Exit</Button>
                <ApprovalsButton route={approvalRoute}/>
                <BusyActionButton color="primary" data-testid="SaveChanges" disabled={isSaveDisabled} onClick={onSave}
                                  className="m-1" busy={saveInProgress}>
                    Save Changes & Submit Later
                </BusyActionButton>
                <BusyActionButton color="primary" data-testid="SubmitPci" disabled={isDisabledSubmitPci}
                                  onClick={() => onSubmitPci(false)} className="m-1" busy={saveInProgress}>
                    SUBMIT PCI
                </BusyActionButton>
                <BusyActionButton color="primary" data-testid="SubmitPciToClientManually"
                                  disabled={isDisabledSubmitManually || saveInProgress}
                                  onClick={() => onSubmitPci(true)}
                                  className="m-1" busy={saveInProgress}>
                    Submit to Client Manually
                </BusyActionButton>
            </ButtonSection>
            <Modal isOpen={openModal} data-testid="NextCancel-ConfirmModal">
                <ModalBody>
                    {'Are you sure you want to exit? - Unsaved changes will be lost'}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={onConfirmCancel}>Yes</Button>
                    <Button color="primary" onClick={toggle}>No</Button>
                </ModalFooter>
            </Modal>
        </Row>
    )
};

export default PCIActionButtons
